<template lang="pug">
    ol.breadcrumb.p-t-0.b-b-0.m-b-0.p-l-0
        li 
            a(:href="indexUrl") {{ trans('general.order') }} {{ trans('general.grid') }} Layout

        li.breadcrumb-item(v-if="!hasPreviousPages") {{ orderLayout.name }}
        template(v-else)
            li.breadcrumb-item(v-for="page in previousPages")
                a(@click="viewGroup(page.group_id)") {{ groupName(page) }}
            li.breadcrumb-item.active {{ groupName(activePage) }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    computed: {
        ...mapGetters('orderLayout', [
            'previousPages',
            'orderLayout',
            'getGroupById',
            'hasPreviousPages',
            'activePage',
        ]),

        indexUrl() {
            return Laroute.route('franchise.order_layout.index');
        },
    },

    methods: {
        ...mapActions('orderLayout', ['viewGroup']),

        groupName(page) {
            if (page.group_id === null) {
                if (this.orderLayout) {
                    return this.orderLayout.name;
                }
            }

            const group = this.getGroupById(page.group_id);
            if (group) return group.name;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/order-layout/order-layout-breadcrumb.vue